import Big from 'big.js';


const toFixed = (value: string | number) => {
  let temp = new Big(value)
  return temp.toFixed(2);
}

export default toFixed;